import React from "react";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import mdEntityService from "core/metamodel/mdEntityService";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {preSave, IDomainObject, pickLov, lovValue} from "core/form/formUtils";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import eventService from "core/event/eventService";
import ActivityTemplateForm from "core/event/component/activityTemplateForm";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {ActivityTemplate} from "core/event/eventDomain";
import uiService from "core/common/service/uiService";
import {action, observable} from "mobx";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import DocumentTemplateResourceList from "core/document/component/documentTemplateResourceList";
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import {debounce} from "core/common/utils/utils";
import {computeHeight} from "core/common/utils/domUtils";
import documentService from "core/document/documentService";
import RadioButtonGroup from 'material-ui/RadioButton/RadioButtonGroup';
import RadioButton from 'material-ui/RadioButton';
import {LovItem} from "core/metamodel/mdEntity";
import {timeout} from "rxjs/operator/timeout";
import {loc} from "../common/config/locales";


let AceEditor, EmailEditor;

const editorTypes: LovItem[] = [{value: 'simple', label: 'Simple'}, {value: 'advanced', label: 'Advanced'}];

@observer
export default class ActivityTemplateDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Activity Template';
  static icon = 'file-code-o';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("ActivityTemplateDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['ActivityTemplate', "DocumentTemplateResource"]);

    let activityTemplatePromise: Promise<ActivityTemplate>;

    if (routerParams.id === 'new') {
      activityTemplatePromise = Promise.resolve(new ActivityTemplate({$new: true, activityConfig: pickLov(query)} as any));
    } else if (routerParams.id === 'copy') {
      activityTemplatePromise = eventService.readActivityTemplate(query.copyId)
        .then(activityTemplateObject => {
          activityTemplateObject.cleanOnCopy();
          activityTemplateObject.templateIndex = undefined;
          return activityTemplateObject;
        })
    } else {
      activityTemplatePromise = eventService.readActivityTemplate(routerParams.id);
    }


    return Promise.all([metadataPromise, activityTemplatePromise])
      .then(([entityMap, activityTemplateObject]: [any, ActivityTemplate]) => {
        eventService.activityTemplateObject = activityTemplateObject.initAfterRead(false);
        if (eventService.activityTemplateObject.defaultEmailBody == null) eventService.activityTemplateObject.defaultEmailBody = '';
      });
  }

  private editorRef: any;
  onResizeDebounced: any;

  @observable editorType: string =  (eventService.activityTemplateObject.defaultEmailDesign) ? lovValue(editorTypes[1]) : lovValue(editorTypes[0]);
  @observable editorHeight: number = 500;

  _aceEditorBody: React.ReactInstance;
  @observable private activeTab: string;


  aceEditorBodyRefHandler = c => this._aceEditorBody = c;

  componentWillMount() {
    require.ensure(['react-ace', 'brace', 'brace/mode/html', 'brace/theme/github', 'brace/ext/searchbox'], (require) => {
      if (AceEditor) {
        return;
      }

      AceEditor = (require('react-ace') as any).default;
      const brace = require("brace");
      require('brace/mode/html');
      require('brace/theme/github');
      require('brace/ext/searchbox');


      this.forceUpdate();

    }, "reactAce");

    require.ensure(['react-email-editor', 'react-load-script'], (require) => {
      if (EmailEditor) {
        return;
      }

      require('react-load-script');
      EmailEditor = (require('react-email-editor') as any);

      this.forceUpdate();

    }, "reactEmailEditor");

  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    this.onResizeDebounced = debounce(this.onResize, 15, false);
    window.addEventListener('resize', this.onResizeDebounced);
  }



  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeDebounced);
    eventService.activityTemplateObject = null;
  }

  customValidate = (activityTemplateObject) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return eventService.activityTemplateObject;
  }


  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    if (!preSave(eventService.activityTemplateObject, this.customValidate)) {
      return;
    }

    if (this.editorType == 'advanced') {
      this.editorRef.exportHtml(data => {
        eventService.activityTemplateObject.defaultEmailBody = data.html;
        eventService.activityTemplateObject.defaultEmailDesign = JSON.stringify(data.design);
        this.onSaveInner();
      });
    } else {
      eventService.activityTemplateObject.defaultEmailDesign = null;
      this.onSaveInner();
    }


  };


  onSaveInner = () => {
    eventService.saveActivityTemplate(eventService.activityTemplateObject.prepareForServer())
      .then(action("activityTemplateSave-callback", (activityTemplateJson: IDomainObject) => {
        let wasNew = eventService.activityTemplateObject.cleanAfterSave(activityTemplateJson);
        if (wasNew) {
          this.context.router.replaceWith('activityTemplateDetail', {id: eventService.activityTemplateObject.id});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        eventService.activityTemplateObject.$errors = error.getMessages();
      });
  };

  @action onDelete = (evt) => {
    console.log('onDelete');

    eventService.deleteActivityTemplate(eventService.activityTemplateObject.activityConfig.value as string, eventService.activityTemplateObject.templateIndex)
      .then(response => {
        this.context.router.transitionTo('activityConfigDetail', {id: eventService.activityTemplateObject.activityConfig.value});
      }, error => {
        eventService.activityTemplateObject.$errors = error.getMessages();
      });
  };

  onAdd = (evt) => {
    console.log('onAdd');
    this.context.router.transitionTo("activityTemplateDetail", {id: 'new'}, eventService.activityTemplateObject.activityConfig);
  };

  onCopy = (evt) => {
    console.log('onCopy');
    this.context.router.transitionTo("activityTemplateDetail", {id: 'copy'}, {copyId: eventService.activityTemplateObject.id});
  };


  @action onChangeDefaultEmailBody = (newValue) => {
    console.log('onChangeDefaultEmailBody');
    eventService.activityTemplateObject.defaultEmailBody = newValue;
    eventService.activityTemplateObject.$dirty = true;
  };


  render() {

    const {
      query
    } = this.props;


    const propsForCreateForm = {
      dataObject: eventService.activityTemplateObject,
      rootObject: eventService.activityTemplateObject,
      entity: mdEntityService.getEntity('ActivityTemplate'),
      entities: mdEntityService.entityMap
    };

    console.log('editorType', this.editorType);

    return (

      <main className="main-content" style={{display: 'flex', flexDirection: 'column', width: "100%"}}>
        {this._createToolMenu(eventService.activityTemplateObject, query.gridLocation)}
        <ErrorComp messages={eventService.activityTemplateObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>

        <form style={{marginTop: 10}}>



              <Tabs
                value={this.activeTab}
                onChange={this.handleChange}
              >
                <Tab label="Configuration" value="configuration">
                  <div className="row" style={{marginTop: 10}}>
                    <div className="col-xs-12 col-sm-6">

                      <RadioButtonGroup name="editorType" valueSelected={this.editorType}
                                        onChange={this.onChangeEditorType}>
                        {editorTypes.map( (format, index) => (<RadioButton key={index} value={format.value} label={format.label} style={{ display: 'inline-block', width: '25%' }}/>))}
                      </RadioButtonGroup>


                      <ActivityTemplateForm {...propsForCreateForm}/>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <DocumentTemplateResourceList documentTemplateObject={eventService.activityTemplateObject}
                                                    entities={mdEntityService.entityMap} showType/>
                    </div>
                  </div>
                </Tab>
                <Tab label="Simple Editor" value="editorSimple" disabled={this.editorType !== 'simple'}>
                  <div style={{marginTop: 10}}>
                    {
                      (AceEditor) ?
                        <AceEditor
                          mode="html"
                          theme="github"
                          value={eventService.activityTemplateObject.defaultEmailBody}
                          onChange={this.onChangeDefaultEmailBody}
                          name="DEFAULT_EMAIL_BODY"
                          enableBasicAutocompletion={true}
                          enableLiveAutocompletion={true}
                          editorProps={{$blockScrolling: true}}
                          width="100%"
                          maxLines="Infinity"
                          minLines={10}
                          style={{padding: '5px 0 0 0'}}
                          height={this.editorHeight + "px"}
                          ref={this.aceEditorBodyRefHandler}
                        />
                        : "Loading...."
                    }
                  </div>
                </Tab>

                <Tab label="Advanced Editor" value="editorAdvanced" disabled={this.editorType !== 'advanced'} >
                  <div style={{marginTop: 10}}>
                    {
                      (EmailEditor) ?
                        <EmailEditor
                          ref={editor => this.editorRef = editor}
                          style={{height: this.editorHeight + "px"}}
                          onLoad={this.onEditorLoad}
                        />
                        : "Loading...."
                    }
                  </div>
                </Tab>


              </Tabs>


        </form>

      </main>




    );
  }


  @action handleChange = (value: string) => {
    console.log("handleChange " + value);
    this.activeTab = value;
    this[this.activeTab]();
  };


  editorSimple() {
  }
  editorAdvanced() {
  }

  configuration() {

  }

  @action onResize = (evt?: any) => {
    let bodyRect = document.body.getBoundingClientRect();
    let _editorHeight = computeHeight(bodyRect, this.editorRef);
    console.log('onResize ', _editorHeight);
    if (_editorHeight > 0) this.editorHeight = _editorHeight;
  };

  @action onEditorLoad = (evt?: any) => {
    console.log('onEditorLoad');
    setTimeout(() => {
      this.onResize();
      this.editorRef.addEventListener('design:updated', function(data) {
        eventService.activityTemplateObject.$dirty = true;
      });
      if (eventService.activityTemplateObject.defaultEmailDesign) this.editorRef.loadDesign(JSON.parse(eventService.activityTemplateObject.defaultEmailDesign));
    }, 0);

  };

  @action onChangeEditorType = (evt, editorType) => {
    console.log('onChangeEditorType ', editorType);
    this.editorType = editorType;
  };


  _createToolMenu(activityTemplateObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1}>
        <ZzFlatButton onClick={this.onSave} disabled={!activityTemplateObject.$dirty} label="Save" permission={activityTemplateObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={activityTemplateObject.$new} label="New" permission={PERMISSION.New}/>
        <ZzFlatButton onClick={this.onCopy} disabled={activityTemplateObject.$new} label="Copy" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="ActivityTemplate" pageAncestor={this} onClick={this.onDelete} disabled={activityTemplateObject.$new} label="Delete" permission={PERMISSION.Delete}/>


      </Toolmenu>
    );
  }

}




// WEBPACK FOOTER //
// ./src/core/event/activityTemplateDetail.tsx